'use client';

import { useLocale } from 'next-intl';
import { useEffect, useState } from 'react';

import { fetchUser } from '../../lib/user';
import { EditLabels } from '../lib/labels';

import { AboutYou, Account, Agreements, Company, DeleteAccount } from '.';

import { useUserStore } from '@utils/user';
import { User } from 'types/user';

interface Props {
  labels: EditLabels;
}

export default function EditDynamicWrapper({ labels }: Props) {
  const [user, setUser] = useState<User | null>(null);
  const userStore = useUserStore();
  const locale = useLocale();

  useEffect(() => {
    if (!userStore.isReady || !userStore.accessToken || !userStore.isLoggedIn) {
      return;
    }

    fetchUser(setUser, userStore.accessToken);
  }, [userStore.isReady]);

  return (
    <>
      <AboutYou labels={labels.aboutYou} />
      <Account labels={labels.account} user={user} />
      <Company labels={labels.company} user={user} />
      {locale !== 'de' && <Agreements labels={labels.agreements} user={user} />}
      <DeleteAccount locale={locale} labels={labels.deleting} user={user} />
    </>
  );
}
